import BaseBtn from './BaseBtn.vue'
import BtnLgDefault from './Btn/BtnLgDefault.vue'
import BtnLgPrimary from './Btn/BtnLgPrimary.vue'
import BtnLgSecondary from './Btn/BtnLgSecondary.vue'
import BtnInfo from './Btn/BtnInfo.vue'
import BAutocomplete from './Inputs/BAutocomplete.vue'
import BBaseYN from './Inputs/BBaseYN.vue'
import BTextField from './Inputs/BTextField.vue'
import BTextArea from './Inputs/BTextArea.vue'
import BNameField from './Inputs/BNameField.vue'
import BCombobox from './Inputs/BCombobox.vue'
import BaseDialog from './BaseDialog.vue'
import BaseDialogAdm from './BaseDialogAdm.vue'
import BaseDialogFull from './BaseDialogFull.vue'
import BaseDialogLayout from './BaseDialogLayout.vue'
import BaseListHeader from './BaseListHeader.vue'
import BaseListContent from './BaseListContent.vue'
import BaseTag from './BaseTag.vue'
import PrimaryTitle from './PrimaryTitle.vue'
import BaseTagCircle from './BaseTagCircle.vue'
import BaseYN from './BaseYN.vue'
import ErrorMessages from './ErrorMessages.vue'
import BaseErrorPage from './BaseErrorPage.vue'
import BaseEditBtn from './BaseEditBtn.vue'
import BaseTitle from './BaseTitle.vue'
import BaseNote from './BaseNote.vue'
import BaseBox from './BaseBox.vue'
import BaseContainer from './BaseContainer.vue'
import SubHeader from './SubHeader.vue'
import SubContent from './SubContent.vue'
import SubTitle from './SubTitle.vue'
import SubTitleQa from './SubTitleQa.vue'
import SubBox from './SubBox.vue'
import SubContentQa from './SubContentQa.vue'
import BSelect from './Inputs/BSelect.vue'
import BSelectDate from './Inputs/BSelectDate'
export {
  // btn
  BaseBtn,
  BtnLgDefault,
  BtnLgPrimary,
  BtnLgSecondary,
  BtnInfo,
  // inputs
  BAutocomplete,
  BBaseYN,
  BTextField,
  BTextArea,
  BNameField,
  BCombobox,
  BSelect,
  BSelectDate,
  //
  BaseDialog,
  BaseDialogAdm,
  BaseDialogFull,
  BaseDialogLayout,
  BaseListHeader,
  BaseListContent,
  BaseTag,
  BaseTagCircle,
  BaseYN,
  ErrorMessages,
  BaseErrorPage,
  BaseEditBtn,
  BaseTitle,
  PrimaryTitle,
  BaseBox,
  BaseContainer,
  SubHeader,
  BaseNote,
  SubContent,
  SubTitle,
  SubTitleQa,
  SubBox,
  SubContentQa
}

const Base = {
  // btn
  BaseBtn,
  BtnLgDefault,
  BtnLgPrimary,
  BtnLgSecondary,
  BtnInfo,
  // inputs
  BAutocomplete,
  BBaseYN,
  BTextField,
  BTextArea,
  BNameField,
  BCombobox,
  BSelect,
  BSelectDate,
  //
  BaseDialog,
  BaseDialogAdm,
  BaseDialogFull,
  BaseDialogLayout,
  BaseListHeader,
  BaseListContent,
  BaseTag,
  BaseTagCircle,
  BaseYN,
  ErrorMessages,
  BaseEditBtn,
  BaseTitle,
  PrimaryTitle,
  BaseBox,
  BaseContainer,
  SubHeader,
  BaseNote,
  SubContent,
  SubTitle,
  SubTitleQa,
  SubBox,
  SubContentQa
}

export default Base
